/**
 * Ticket Z14: Layout-Route für /100-tage/weiterbildung.
 *
 * WICHTIG: Auch diese Adresse steht in gedruckten Materialien. Sie darf nicht
 * entfernt oder umbenannt werden.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/100-tage/weiterbildung")({
  component: () => <Outlet />,
});
